import { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import Loading from "../Component/Loding.jsx";
import SubMenu from "../Component/SubMenu";
import moment from "moment";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import * as Common from "../../Common/common.js";
import mainBg from "../../assets/img/bg-esg-03.jpg";
import modalIcon01 from "../../assets/img/humanMgmt-modal-icon01.png";
import modalIcon02 from "../../assets/img/humanMgmt-modal-icon02.png";
import modalIcon03 from "../../assets/img/humanMgmt-modal-icon03.png";

function HumanRightMgmt() {
    // 권한 체크
    const authCk = Common.fn_authChek();

		//모달
		const [isModalOpen, setIsModalOpen] = useState(false);
		// 스크롤 막기 처리
		useEffect(() => {
			if (isModalOpen) {
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "auto";
			}

			return () => {
				document.body.style.overflow = "auto";
			};
		}, [isModalOpen]);

    // 화면 이동을 위한 네비게이터 설정
		const navigate = useNavigate();
		const [isLoading, setIsLoading] = useState(false);

		// 일반 또는 관리자 header 설정
		const { argInfo } = useContext(ArgContext);
		const isAdmin = argInfo?.role === 'admin';

    // 파일 데이터
    const [imgFile, setImgFile] = useState([]);

		//제보일
    const [emailInfo, setEmailInfo] = useState({
          gubun: "hr"
        , registDate: moment(new Date()).format("YYYY-MM-DD") 
        , registName: ""
				, registMail: ""
        , registTelNo: ""
        , registTitle: ""
        , registContent: ""
        , registRequire: ""
    });

    // 파일 정보 제외한 data 변경 값 set
    const handleChange = (e) => {
        
		const { value, name } = e.target;
        //console.log("name="+name+", value="+value)
		setEmailInfo({
			...emailInfo, // 기존 객체 복사
			[name]: value, // name 키를 가진 값을 value로 설정
		});
	}

    // 파일 변경 데이터 set
    const handleChangeFile = (event) => {
        setImgFile(event.target.files); 
    }

	//신고하기
	// const fn_report = () => {
	// 	setIsLoading(true);
	// 	Common.fn_send(imgFile, emailInfo, "/humanRightMgmt", setIsLoading);
	// }

		const fn_report = () => {
			setIsLoading(true);
			Common.fn_send(imgFile, emailInfo, "/humanRightMgmt", (success) => {
				setIsLoading(false);
				if (success) {
					setIsModalOpen(false);
				}
			});
		}


		//파일다운로드
		const downloadFile = async () => {
			const response = await fetch("/download/humanReport");
			const blob = await response.blob();
		
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = "위피아_인권헌장.pdf";
			a.click();
			a.remove();
			window.URL.revokeObjectURL(url);
		};
    return (
		<>


<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>인권경영</h2>
						<p>위피아는 지속가능한 경영을 위해 사회적 역할과 책임을 다하고 신뢰받는 기업이 되기 위해 노력합니다.</p>
					</div>
					<SubMenu />
			</section>
			
			{/* 인권경영 */}
			<section className="esg-visoinObj human-mgmt">
				<div className="container-auto sec-mt title-box">
						<h3 className="sub-title">인권경영</h3>
						<p className="sub-text">
							위피아는 기업의 경영활동 과정에서 직·간접적으로 일어날 수 있는 모든 인권 침해를 예방하고 관련 리스크를 완화하기 위해 본 인권헌장을 선언한다.<br />
							위피아는 인권경영을 위해 UN 세계인권선언, UN 기업과 인권 이행 지침, OECD 다국적기업 가이드라인, ILO 선언 등 인권, 노동 관련 각종 국제표준 및 가이드라인을 존중하고 준수하겠습니다.
						</p>
				</div>
				<div className="bg-blue sec-py human-mgmt">
					<div className="container-auto">
						<div className="sub-title-box">
							<h4 className="title">인권헌장 적용 범위 및 인권헌장</h4>
							<p className="text">본 인권헌장의 적용 대상은 위피아 소속 임직원 및 모든 고객과 협력사를 포함하며, 거래 관계에 있는 모든 이해관계자가 본 인권헌장을 존중할 수 있도록 권장하여야 한다.</p>
						</div>
						<ul className="enviro-list">
							<li>
								<p className="num">01</p>
								<div className="textBox">
									<p className="title">차별금지</p>
									<p className="text">위피아는 고용전반에 있어 차별을 금지하고 다양성을 존중합니다.</p>
								</div>
							</li>
							<li>
								<p className="num">02</p>
								<div className="textBox">
									<p className="title">성희롱 및 직장내 괴롭힘</p>
									<p className="text">위피아는 성희롱 및 괴롭힘 행위를 금지하며, 피해자 보호를 위한 제도를 마련하고 예방을 위해 최선을 다합니다.</p>
								</div>
							</li>
							<li>
								<p className="num">03</p>
								<div className="textBox">
									<p className="title">안전 및 보건</p>
									<p className="text">위피아는 재해 예방을 위한 안전·보건 관리 체계를 구축하고, 안전·보건 관련 법률을 준수합니다.</p>
								</div>
							</li>
							<li>
								<p className="num">04</p>
								<div className="textBox">
									<p className="title">아동노동 및 강제노동 금지</p>
									<p className="text">위피아는 법정 고용 연령을 준수하며, 연소근로자 고용 시에는 관련 법률을 준수하며, 어떠한 형태의 강제 노동도 금지하며, 공정하고 투명한 근로계약을 체결합니다.</p>
								</div>
							</li>
							<li>
								<p className="num">05</p>
								<div className="textBox">
									<p className="title">근로조건 준수</p>
									<p className="text">위피아는 법에서 정하고 있는 근로시간, 휴게시간, 휴일 규정을 준수하며 급여명세서와 함께 계약서에 명시된 금액을 정해진 일자에 지급합니다.</p>
								</div>
							</li>
							<li>
								<p className="num">06</p>
								<div className="textBox">
									<p className="title">고객 인권 및 개인정보 보호</p>
									<p className="text">위피아는 임직원 및 이해관계자의 생명, 건강, 안전, 재산 등을 해치지 않도록 각별한 주의를 기울이며, 경영활동으로 수집한 개인정보의 보호를 위해 최선의 조치를 취합니다.</p>
								</div>
							</li>
						</ul>
						<div className="signWrap">
							<p className="ceo">㈜위피아 대표이사 김용연 <span className="sign">대표이사 사인</span></p>
						</div>
						<ul className="btnWrap">
							{/* <li><button onClick={()=>{Common.fn_fileDownload("hr")}}>위피아 인권헌장 다운로드</button></li> */}
							<li>
								<button onClick={downloadFile}>위피아 인권헌장 다운로드</button>
							</li>
							
							<li><button className="human-mgmt-modalBtn" onClick={() => setIsModalOpen(true)}>인권침해 및 고충 신고</button></li>
						</ul>
					</div>
				</div>
			</section>
		</main>

		{/* 인권침해 및 고충신고 모달 */}
		{isModalOpen && (
		<div className="modalWrap human-mgmt-modal subpage-modal">
			<div className="modal-inner">
				<div className="modal-title"> 
					<h3 className="title">인권침해 및 고충 신고</h3>
					<button className="close-btn" onClick={() => setIsModalOpen(false)}>닫기</button>
				</div>
				<div className="modal-textBox scroll">
					<h4 className="tit">인권침해 신고</h4>
					<p className="txt">
						- 위피아는 임직원의 인권침해 사실에 대해 신고합니다.<br />
						- 사실에 근거하지 않은 비방, 개인사생활과 관련한 사항은 조사 대상에서 제외하며, 조사 시 추가 필요사항을 요청드릴 수 있습니다.
					</p>

					<section className="report-box">
						<h4 className="tit">제보방법</h4>
						<ul className="list">
							<li>
								<img src={modalIcon01} className="list-icon" />
								<div className="textArea">
									<p className="title">우편신고</p>
									<p className="text">서울특별시 영등포구 경인로 775, 1-507 (문래동3가 , 에이스하이테크시티)</p>
								</div>
							</li>
							<li>
								<img src={modalIcon02} className="list-icon" />
								<div className="textArea">
									<p className="title">유선신고</p>
									<p className="text">02-2038-8311</p>
								</div>
							</li>
							<li>
								<img src={modalIcon03} className="list-icon" />
								<div className="textArea">
									<p className="title">온라인신고</p>
									<p className="text">홈페이지 : www.wipia.co.kr</p>
								</div>
							</li>
						</ul>
					</section>
					<section className="report-table">
						<h4 className="tit">인권침해 신고하기</h4>
						<p className="txt">
							※ 위피아는 신고자의 신분을 최우선으로 보호합니다.<br />
							※ 인권침해 신고를 위해 수집된 개인정보는 목적 외의 용도로 사용하지 않겠습니다.<br />
							※ 사실에 근거하지 않은 비방, 개인사생활과 관련한 사항은 조사 대상에서 제외하며, 조사시 추가 필요사항을 요청드릴 수 있습니다.
						</p>
						
						<div className="tableWrap">
							<form className="needs-validation" noValidate>

								<div className="tableBox">
									<div className="list-ly02">
										<p className="title">제보일</p>
										<div className="text"><input type="text" id="fn" value={emailInfo.registDate} required disabled/></div>
										<p className="title">제보자 메일</p>
										<div className="text"><input type="text" name="registMail" onChange={handleChange} required/></div>
									</div>

									<div className="list-ly02">
										<p className="title">제보자 성명</p>
										<div className="text"><input type="text" name="registName" onChange={handleChange} required/></div>
										<p className="title">연락처</p>
										<div className="text"><input type="text" name="registTelNo" onChange={handleChange}/></div>
									</div>

									<div className="list-ly01">
										<p className="title">제목</p>
										<div className="text"><input type="text" name="registTitle" onChange={handleChange}/></div>
									</div>
									<div className="list-ly01">
										<p className="title">내용</p>
										<div className="text"><textarea type="text" name="registContent" onChange={handleChange} /></div>
									</div>
									<div className="list-ly01">
										<p className="title">요구사항</p>
										<div className="text"><textarea type="text" name="registRequire" onChange={handleChange} /></div>
									</div>
									<div className="list-ly01">
										<p className="title">증빙(선택)</p>
										<div className="text"><input type="file" className="rounded-start" onChange={handleChangeFile} multiple/></div>
									</div>
								</div>
								
								<button type="button" className="submit-btn" onClick={()=>{fn_report()}}>신고하기</button>
							</form>
						</div>
					</section>
					
				</div>
			</div>
			<div className="bg-b" onClick={() => setIsModalOpen(false)}></div>
		</div>
		)}

	<Footer />
	<Loading active={isLoading}/>
        </>
    )
}

export default HumanRightMgmt;